import React from 'react'
import styles from '../styles/BannerSection.module.css'
import { BsArrowUpRight } from "react-icons/bs";
import { GoDotFill } from "react-icons/go";
import client1 from '../../../../assets/Landing/person1.jpg';
import client2 from '../../../../assets/Landing/person2.jpg';
import client3 from '../../../../assets/Landing/person3.jpg';
import bannerImg1 from '../../../../assets/Landing/banner-img1.jpg';
import bannerImg2 from '../../../../assets/Landing/banner-img2.jpg';
import bannerImg3 from '../../../../assets/Landing/banner-img3.jpg';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const BannerSection = () => {
    return (
        <div className=''>
            <div className={`container-fluid ${styles.main_container}`}>
                <div className='row'>
                    <div className='col-lg-6 col-md-12 col-sm-12'>
                        <div className={styles.left_section}>
                            <div className={styles.header_wrapper}>
                                <h2>Empower your Workforce with Smarter Training</h2>
                                <p>The smart digital learning platform built for enterprise upskilling</p>
                                <Link to='/signup'>
                                    <button><span><GoDotFill /></span> Get Started <span><BsArrowUpRight /></span></button>
                                </Link>
                               
                            </div>
                            <div className={styles.client_section}>
                                <div className={styles.client_img}>
                                    <div className={styles.img_container}>
                                        <img src={client1} alt="" />
                                    </div>
                                    <div className={styles.img_container}>
                                        <img src={client2} alt="" />
                                    </div>
                                    <div className={styles.img_container}>
                                        <img src={client3} alt="" />
                                    </div>
                                </div>
                                <div className={styles.text_wrapper}>
                                    <h4>100+</h4>
                                    <p>Satisfied Clients</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6 col-md-12 col-sm-12'>
                        <div className={styles.right_section}>
                            <div className={` ${styles.top_img_section}`}>
                                <img src={bannerImg1} alt="" className={styles.image1} />
                                <img src={bannerImg2} alt="" className={styles.image2} />
                            </div>
                            <div className={styles.bottom_img_section}>
                                <img src={bannerImg3} alt="" className={styles.image3} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BannerSection